
import React from 'react';
import { FormButton } from './FormButton';

interface FormDisplayProps {
  matches: any[];
  team: string;
  onMatchClick: (team: string, match: any) => void;
}

export const getLastSixForm = (matches: any[], team: string, viewType: 'all' | 'home' | 'away'): any[] => {
  const teamMatches = matches.filter(match => {
    if (viewType === 'home') return match.HomeTeam === team;
    if (viewType === 'away') return match.AwayTeam === team;
    return match.HomeTeam === team || match.AwayTeam === team;
  });

  return teamMatches.slice(-6);
};

export const FormDisplay: React.FC<FormDisplayProps> = ({ matches, team, onMatchClick }) => {
  return (
    <div className="flex gap-0.5 justify-center">
      {matches.map((match, idx) => {
        const isHome = match.HomeTeam === team;
        const result = isHome 
          ? match.FTR === 'H' ? 'W' : match.FTR === 'A' ? 'L' : 'D'
          : match.FTR === 'A' ? 'W' : match.FTR === 'H' ? 'L' : 'D';
        
        return (
          <FormButton
            key={idx}
            result={result}
            onClick={() => onMatchClick(team, match)}
          />
        );
      })}
    </div>
  );
};
